export default __webpack_public_path__ + "static/media/kindergarten.fae83ef3.svg";